import { FormHandles } from "models/propTypes/genericFormProps";
import { useLocation, useNavigate } from "react-router-dom";
import { TodoConstants } from "utils/constants";
import { UrlHelper } from "utils/helpers";

function useGenericDocumentViewInfo(id: number | string, formRef: React.RefObject<FormHandles>) {
  const location = useLocation();
  const navigate = useNavigate();

  const getUpdatedValues = () => {
    return (formRef.current && formRef.current.getUpdatedValues && formRef.current.getUpdatedValues()) || {};
  };

  const onViewButtonClick = () => {
    navigate(UrlHelper.formatPath(`/AccountingDocument/${id}`), {
      state: {
        background: location,
        [TodoConstants.RouteTodoSelectionKey]: getUpdatedValues && getUpdatedValues(),
      },
    });
  };

  return onViewButtonClick;
}

export default useGenericDocumentViewInfo;
